import * as yup from "yup";

export const locationSchema = yup
  .object({
    name: yup.string().required().default(""),
    address_line_1: yup.string().default("").required(),
    address_line_2: yup.string().default("").nullable(),
    city: yup.string().default("").nullable(),
    state: yup.string().default("").nullable(),
    zip: yup.string().default("").nullable(),
  })
  .required();
